<app-ngbox></app-ngbox>
<app-toolbar [sidenav]="sidenav"></app-toolbar>
<mat-sidenav-container class="admin-container" (backdropClick)="sidenav.close()">
	<mat-sidenav class="sidenav" opened="false" position="start" mode="over" #sidenav>
		<app-sidenav></app-sidenav>
	</mat-sidenav>
	<div class="content-container">
		<div class="loading-overlay" [class.show]="isLoading">
			<mat-progress-bar [mode]="progress_type" [value]="progress_percentage"></mat-progress-bar>
		</div>
		<div *ngIf="loadingError" class="alert alert-danger" fxFlex fxLayoutAlign="center" fxLayout="row">
			<h2>Er is een fout opgetreden bij het laden van de data.</h2>
		</div>
		<div *ngIf="offlineError" class="alert alert-danger" fxFlex fxLayoutAlign="center" fxLayout="row">
			<h2>Niet alle data is beschikbaar online, ga online om verder te gaan.</h2>
		</div>
		<div *ngIf="tfa_required" class="alert alert-danger" fxFlex fxLayoutAlign="center" fxLayout="row">
			<h2>Om deze app te gebruiken moet tweefactorauthenticatie zijn ingeschakeld.</h2>
		</div>
		<div *ngIf="tfa_not_enabled" class="alert alert-danger" fxFlex fxLayoutAlign="center" fxLayout="row">
			<h2>Uw tweefactorauthenticatie is nog niet geactiveerd. Om uw account beter te beveiligen raden wij u aan om twee-factor-authenticatie in te schakelen.</h2>
		</div>
		<router-outlet></router-outlet>
	</div>
</mat-sidenav-container>
<app-toolbar-bottom></app-toolbar-bottom>
